export const stepTitle = {
    review: "Illustration ready",
};
